import { z } from "zod";
export const feedbackItem = z.object({
  id: z.uuid(),
  userId: z.uuid(),
  nickname: z.string().nullable(),
  category: z.enum(["suggestion", "bug", "complaint"]),
  message: z.string(),
  context: z.record(z.string(), z.string()),
  createdAt: z.iso.datetime(),
  reviewedAt: z.iso.datetime().nullable(),
  reviewedBy: z.uuid().nullable(),
  reply: z.string().nullable(),
  repliedAt: z.iso.datetime().nullable(),
  repliedBy: z.uuid().nullable(),
});
export const feedbackPage = z.object({
  items: z.array(feedbackItem),
  nextCursor: z.uuid().nullable(),
});
export const feedbackSummary = z.object({ newCount: z.number().int().nonnegative() });
export const feedbackReview = feedbackItem.pick({ id: true, reviewedAt: true, reviewedBy: true });
export const feedbackReply = feedbackItem.pick({
  id: true,
  reply: true,
  repliedAt: true,
  repliedBy: true,
  reviewedAt: true,
  reviewedBy: true,
});
export type FeedbackItem = z.infer<typeof feedbackItem>;
export type FeedbackFilters = {
  status: "new" | "reviewed" | "reviewed_unreplied" | "replied" | "all";
  category?: FeedbackItem["category"];
  search?: string;
  before?: string;
};
